// extracted by mini-css-extract-plugin
export default {"root":"PayPalElements_root__C95-9","errorContainer":"PayPalElements_errorContainer__v1oFP","progressBar":"PayPalElements_progressBar__QMHNQ"};